/**
 * The logo on the match tracker ad-boards: the skin's own logo when it has one,
 * otherwise the Sirplay logo, but only when the skin shows the Sirplay licence
 * (settings/getShowSirplayLicence, same rule as the logo on the field). An empty
 * string makes the boards show their text instead.
 *
 * The Sirplay logo is passed in (BOARD_LOGO from broadcastScene, a bundled asset)
 * so this stays a plain function.
 *
 * @param {string|null} skinLogoUrl - settings/getSkinLogoUrl
 * @param {boolean|null} showSirplayLicence - settings/getShowSirplayLicence
 * @param {string} sirplayLogo - BOARD_LOGO
 * @returns {string}
 */
export function resolveBoardLogo(skinLogoUrl, showSirplayLicence, sirplayLogo) {
    if (skinLogoUrl) return skinLogoUrl;
    return showSirplayLicence === true ? sirplayLogo : '';
}
